import type { AppointmentStatus, AppointmentType } from 'services/types/appointment';
import { NAVY, STATUS_GOOD, STATUS_WARN } from 'styles/tokens';

export const TYPE_STYLES: Record<AppointmentType, { accent: string; surface: string; rail: string }> = {
  mantencion: { accent: '#2C859B', surface: 'rgba(71, 188, 216, 0.14)', rail: '#47BCD8' },
  dyp: { accent: '#8D7500', surface: 'rgba(249, 208, 10, 0.16)', rail: '#EAC300' },
  repuestos: { accent: NAVY, surface: 'rgba(21, 24, 58, 0.06)', rail: 'rgba(21, 24, 58, 0.45)' },
  'cambio-aceite': { accent: '#2C5889', surface: 'rgba(100, 148, 198, 0.16)', rail: '#6494C6' },
  diagnostico: { accent: '#705D00', surface: 'rgba(202, 168, 0, 0.14)', rail: '#CAA800' },
};

export const STATUS_STYLES: Record<AppointmentStatus, { color: string; surface: string }> = {
  done: { color: STATUS_GOOD, surface: 'rgba(83, 183, 33, 0.12)' },
  pending: { color: STATUS_WARN, surface: 'rgba(207, 92, 9, 0.12)' },
  cancelled: { color: 'rgba(21, 24, 58, 0.4)', surface: 'rgba(21, 24, 58, 0.06)' },
};

export const WEEKDAYS_SHORT = ['LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB', 'DOM'];
export const WEEKDAYS_LONG = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];
export const MONTHS = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

/** Day timeline bounds (week & day views). */
export const START_HOUR = 8;
export const END_HOUR = 19;
export const HOUR_HEIGHT = 64; // px per hour row

export type ServiceCalendarView = 'month' | 'week' | 'day';
